import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useTranslation } from 'react-i18next';

export default function ScheduledSpotCancelConfirmationModal({ show, onCancel, onConfirm, orderId }) {
    const { t } = useTranslation();
    const [actionInProgress, setActionInProgress] = useState(false);

    // Reset actionInProgress when modal is shown/hidden
    useEffect(() => {
        if (show) {
            setActionInProgress(false);
        }
    }, [show]);

    const handleCancel = () => {
        if (!actionInProgress) {
            setActionInProgress(true);
            onCancel();
        }
    };

    const handleConfirm = () => {
        if (!actionInProgress) {
            setActionInProgress(true);
            onConfirm(orderId);
        }
    };

    return (
        <Modal show={show} onHide={handleCancel} centered className="td-modal modal-lg">
            <Modal.Header>
                <Modal.Title><h2>{t('td.fx.ticket.scheduledspot.delete.title')}</h2></Modal.Title>
            </Modal.Header>
            <Modal.Body className="td-modal-body-shown">
                <p>{t('td.fx.ticket.scheduledspot.delete.message')}</p>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    className="btn td-btn-primary-light"
                    onClick={handleConfirm}
                    disabled={actionInProgress}
                >
                    {t('td.fx.ticket.scheduledspot.delete.yes')}
                </Button>
                <Button
                    className="btn td-btn-secondary-clear"
                    onClick={handleCancel}
                    disabled={actionInProgress}
                >
                    {t('td.fx.ticket.scheduledspot.delete.no')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

